import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { lawrenceConfig } from "./data";

export default function LawrencePage() {
  return <CityPageTemplate config={lawrenceConfig} />;
}